import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: number = 0;

export const contractIdSlice = createSlice({
 name: 'contractId',
 initialState,
 reducers: {
  contractId: (state, action: PayloadAction<number>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { contractId } = contractIdSlice.actions;

export default contractIdSlice.reducer;
